import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

export const fetchContentFromFirebase = async (id) => {
  if (!id) {
    console.error('No document ID provided');
    return [];
  }

  try {
    const docRef = doc(db, 'contents', id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      
      if (data.sections && Array.isArray(data.sections)) {
        return data.sections;
      } else if (data.content && Array.isArray(data.content)) {
        return data.content;
      }
      console.error('No valid sections array found:', data);
      return [];
    }
    console.error(`No document found with ID: ${id}`);
    return [];
  } catch (error) {
    console.error('Error fetching content:', error);
    return [];
  }
};
